import request from '@utils/request.js'

export function getEnterprisePageList (parameter) {
    return request({
      url: '/auth/rest/enterprise/get_page',
      method: 'get',
      params: parameter
    })
  }
  export function addEnterprise(parameter){
    return request({
        url: '/auth/rest/enterprise/add',
        method: 'post',
        data: parameter
      })
  }
  export function getEnterprise(parameter){
    return request({
        url: '/auth/rest/enterprise/get/'+`${parameter}`,
        method: 'get'
      })
  }
  export function updateEnterprise(parameter){
    return request({
        url: '/auth/rest/enterprise/update',
        method: 'post',
        data: parameter
      })
  }
  export function removeEnterprise(parameter){
    return request({
        url: '/auth/rest/enterprise/remove',
        method: 'post',
        data: parameter
      })
  }
  export function getAllEnterprise(parameter){
    return request({
        url: '/auth/rest/enterprise/get_all',
        method: 'get'
      })
  }